import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(({ spacing, palette, breakpoints }) => ({
	root: {
		marginBottom: spacing(5),
		overflow: 'hidden',
		[breakpoints.up('sm')]: {
			display: 'flex'
		}
	},
	report: {
		flexBasis: '25%',
		padding: spacing(3.5, 2, 2.5),
		backgroundColor: palette.grey.light[1],
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		'& h3': {
			fontSize: '2.9rem',
			marginBottom: spacing(0.5)
		}
	},
	list: {
		padding: 0,
		justifySelf: 'flex-end',
		flexBasis: '75%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center'
	},
	listItemTop: {
		padding: spacing(2, 3, 0.5)
	},
	listItemBottom: {
		padding: spacing(0.5, 3, 1)
	},
	listItemTotal: {
		padding: spacing(1, 3, 1.5)
	},
	itemTextLeft: {
		marginRight: 'auto',
		flex: 'none',
		minWidth: '20%',
		margin: 0,
		'& > span': {
			fontSize: '.93rem',
			fontWeight: 500,
			[breakpoints.up('sm')]: {
				fontSize: '.95rem'
			},
			[breakpoints.up('md')]: {
				fontSize: '1rem'
			}
		}
	},
	itemTextRight: {
		textAlign: 'right',
		minWidth: '26%',
		flex: 'none',
		margin: 0,
		'& > span': {
			fontSize: '1rem',
			fontWeight: 500,
			[breakpoints.up('md')]: {
				fontSize: '1.1rem'
			}
		}
	},
	overallBar: {
		height: '8px !important',
		backgroundColor: `${palette.secondary.main} !important`,
		'& > div': {
			transition: 'transform .8s linear'
		}
	},
	bar: {
		flex: '1 1 auto',
		border: '1px solid',
		borderRadius: 10,
		height: '12px !important',
		backgroundColor: 'transparent !important',
		[breakpoints.up('sm')]: {
			margin: spacing(0, 1)
		},
		'& > div': {
			transition: 'transform .8s linear'
		}
	},
	totalTitle: {
		'& span': {
			fontSize: '.95rem',
			[breakpoints.up('sm')]: {
				fontSize: '1rem'
			},
			[breakpoints.up('md')]: {
				fontSize: '1.05rem'
			}
		}
	},
	totalAmount: {
		'& span': {
			fontSize: '1.05rem',
			[breakpoints.up('sm')]: {
				fontSize: '1.1rem'
			},
			[breakpoints.up('md')]: {
				fontSize: '1.2rem'
			}
		}
	}
}));
